import { getDBIdFromGraphqlId } from 'src/utils/commonFunctions';

export const getTotalFees = async (fund, className, client, date) => {
  try {
    const fundId = fund ? getDBIdFromGraphqlId(fund).toString() : null;
    const clientId = client ? getDBIdFromGraphqlId(client).toString() : null;

    const params = new URLSearchParams();

    if (fundId) params.append('fundUuid', fundId);
    if (className) params.append('className', className);
    if (clientId) params.append('investorUuid', clientId);
    if (date)
      params.append(
        'dateUntil',
        date
          .split('/')
          .reverse()
          .join('-'),
      );

    const ropUrl = `${process.env.REACT_APP_ROP_MOVEMENTS_URL}/tir-report?${params}`;

    const response = await fetch(ropUrl, {
      method: 'GET',
      headers: {
        'x-token': `${process.env.REACT_APP_ROP_TOKEN}`,
        'x-api-key': `${process.env.REACT_APP_ROP_APIKEY}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Connection failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data?.investors?.[0]?.totalFees ?? 0;
  } catch (error) {
    console.error('Error getting total fees:', error);
    throw error;
  }
};
